import { useGetMediaThumbnail } from '@cobliteam/hooks/src/useCamera/useCameraMedia';
import Icon from '@cobliteam/ui/icons';

interface RiskFootageThumbnailProps {
  /** mediaId do clipe (de `metadata.media_ids`). Busca o thumbnail em /media. */
  mediaId?: string;
  /** Poster local (`signed_media_urls`) usado como fallback enquanto/se o /media não trouxer thumbnail. */
  poster?: string;
  /** Só busca quando true (ex.: célula visível / modal aberto). */
  enabled?: boolean;
}

/**
 * Imagem do thumbnail de um clipe. Busca `thumbnail_url` em /media (getMediaThumbnail) pelo mediaId; cai no
 * poster do vídeo (`signed_media_urls`, 1º frame) e, por fim, num placeholder de vídeo. Preenche o container
 * pai (`size-full`) — quem define tamanho/borda é o pai.
 */
const RiskFootageThumbnail = ({ mediaId, poster, enabled = true }: RiskFootageThumbnailProps) => {
  const { data: thumbnailUrl } = useGetMediaThumbnail(mediaId, { enabled: enabled && Boolean(mediaId) });

  if (thumbnailUrl) {
    // alt vazio: decorativo; o botão/aria do pai já rotula.
    return <img src={thumbnailUrl} alt='' className='size-full object-cover' />;
  }

  if (poster) {
    return <video src={`${poster}#t=0.1`} muted playsInline preload='metadata' aria-hidden className='size-full object-cover' />;
  }

  return (
    <span className='flex size-full items-center justify-center bg-gray-11' aria-hidden>
      <Icon name='video' size='sm' className='text-white/80' />
    </span>
  );
};

export default RiskFootageThumbnail;
